import { BaseError } from "../base/BaseError";

export class FailedRequestError extends BaseError {
    message ="خطأ غير متوقع، الرجاء التحقق من اتصالك بالانترنت";
}
